import { GET_ORGS, convertResult, convertParams } from 'app/common/api/requests/food/schools/get'
import { Params } from 'app/dataTypes/org'

import { api } from 'app/api'

export const getOrgs = async (params: Params, signal?: AbortSignal) => {
  const res = await api.request(GET_ORGS, {
    additionalAxiosOptions: {
      signal,
    },
    error: 'Не удалось получить данные классов',
    params,
    convertions: {
      convertParams,
      convertResult,
    },
  })

  return res
}
